import React, { ReactNode, useEffect, useState } from 'react';
import { me } from '@/services/auth/authService';
import { logoutOtherUserDevices, updateRegisteredUser } from '@/services/user/user.service';
import { usePrivy } from '@privy-io/react-auth';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';
import ConfirmationModal from '@/components/ConfirmationModal/ConfirmationModal';
import { useDispatch, useSelector } from 'react-redux';
import { ReducerState } from '@/services/common/lib/reducerState';
import { LobbyRemoveDuplicateLogin } from '@/services/lobby/lobbyActions';

const DoubleLoginModal = (): ReactNode => {
  const { authenticated, user: privyUser, logout } = usePrivy();
  const dispatch = useDispatch();
  const { getData } = useVisitorData({ extendedResult: true, linkedId: privyUser?.id as string }, { immediate: false });
  const visitorIdToKeep = useSelector((state: ReducerState) => state.lobby.visitorIdToKeep);

  useEffect(() => {
    if (visitorIdToKeep && authenticated && !!process.env.REACT_APP_FINGERPRINT_KEY) {
      getData().then((d) => {
        if (visitorIdToKeep !== d.visitorId) {
          dispatch(LobbyRemoveDuplicateLogin());
          void logout();
        }
      });
    }
  }, [visitorIdToKeep]);

  const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);
  const [visitorId, setVisitorId] = useState<string | null>(null);

  useEffect(() => {
    if (authenticated && !!process.env.REACT_APP_FINGERPRINT_KEY) {
      Promise.all([getData(), me()]).then(([d, user]) => {
        if (user.data.visitorId && user.data.visitorId !== d.visitorId) {
          console.log('Double login detected');
          setVisitorId(d.visitorId);
          setShowConfirmationModal(true);
        } else {
          console.log('Single login detected');
          void updateRegisteredUser({ visitorId: d.visitorId });
        }
      });
    }
  }, [authenticated]);

  return (
    <ConfirmationModal
      open={showConfirmationModal}
      onClose={() => {
        console.log('Double login modal closed');
        setShowConfirmationModal(false);
        void logout();
      }}
      onClickConfirm={async () => {
        console.log('Double login modal confirmed');
        void logoutOtherUserDevices({ visitorId });
        setShowConfirmationModal(false);
      }}
      message="You are already logged in on another device. Do you want to use this device instead? This will disconnect you from the other devices."
      confirmText="Yes, use this device"
      cancelText="No, log me out"
    />
  );
};

export default DoubleLoginModal;
